import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box,
    Avatar,
    Menu,
    MenuItem,
    Tooltip,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    CssBaseline,
} from '@mui/material';

import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ShowChartIcon from '@mui/icons-material/ShowChart';


// Mock user data for the example
const mockUserData = {
    name: 'Shivamba ',
    email: '',
};

// -----------------------------------------------------------------------------
// Shopheader Component
// -----------------------------------------------------------------------------
const Payroleheader = ({ onMenuClick }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleLogout = () => {
        // In a real application, you would handle the sign-out logic here
        console.log('User signed out.');
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const userInitial = mockUserData?.name?.charAt(0)?.toUpperCase() || 'U';

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                background: 'linear-gradient(90deg, #920386ff 0%, #b73a42ff 50%, #b06927ff 100%)',
            }}
        >
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={onMenuClick}
                    sx={{ mr: 2 }}
                >
                    <MenuIcon />
                </IconButton>

                <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
                    श्रीरामजी
                </Typography>

                <Box>
                    <Tooltip title="Profile">
                        <IconButton onClick={handleMenuOpen} size="small" sx={{ ml: 2 }}>
                            <Avatar sx={{ width: 32, height: 32 }}>
                                {userInitial}
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        onClick={handleMenuClose}
                        PaperProps={{
                            elevation: 3,
                            sx: { mt: 1.5 },
                        }}
                    >
                        <MenuItem disabled>
                            <Typography variant="subtitle1">
                                {mockUserData?.name || mockUserData?.email || 'Guest'}
                            </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                            Logout
                        </MenuItem>
                        <MenuItem component={Link} to="/home" >
                            Back To Home
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

// -----------------------------------------------------------------------------
// Sidebar Component
// -----------------------------------------------------------------------------
const drawerWidth = 240;

const Sidebar = ({ isOpen, onClose }) => {
    const [openStaff, setOpenStaff] = useState(false);
    const [openReports, setOpenReports] = useState(false);

    return (
        <Drawer
            variant="temporary"
            open={isOpen}
            onClose={onClose}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    background: 'linear-gradient(to bottom, #9a0b0bff, #b45808ff)',
                    color: '#fff',
                    borderRight: 'none',
                },
            }}
            elevation={3}
        >
            {/* Toolbar spacing */}
            <Toolbar />

            <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />

            <List component="nav">
                {/* Staff Main Menu */}
                <ListItemButton component={Link} to="/category/payroll" sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}>
                        <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItemButton>

                <ListItemButton onClick={() => setOpenStaff(!openStaff)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}><PersonIcon /></ListItemIcon>
                    <ListItemText primary="कर्मचारी" />
                    {openStaff ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openStaff} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/staff/category" sx={styles.subMenuItem}>
                            <ListItemText primary="कर्मचारी श्रेणी" />
                        </ListItemButton>

                        <ListItemButton component={Link} to="/staff/details" sx={styles.subMenuItem}>
                            <ListItemText primary="कर्मचारी तपशील" />
                        </ListItemButton>

                        <ListItemButton component={Link} to="/staff/advance-payment" sx={styles.subMenuItem}>
                            <ListItemText primary="कर्मचारी उचल  " />
                        </ListItemButton>

                        <ListItemButton component={Link} to="/staff/monthly-payment" sx={styles.subMenuItem}>
                            <ListItemText primary="कर्मचारी मासिक पेमेंट" />
                        </ListItemButton>
                    </List>
                </Collapse>

                <ListItemButton onClick={() => setOpenReports(!openReports)} sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}>
                        <ShowChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="रिपोर्ट " />
                    {openReports ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={openReports} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton component={Link} to="/reports-staff-payments" sx={{ pl: 4 }}>
                            <ListItemText primary="कर्मचारी पेमेंट रिपोर्ट " />
                        </ListItemButton>
                    </List>
                </Collapse>

            </List>
        </Drawer>
    );
};


const styles = {
    menuItem: {
        px: 2,
        py: 1.5,
        color: '#fff',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
    menuIcon: {
        color: '#fff',
        minWidth: '40px',
    },
    subMenuItem: {
        pl: 5,
        py: 1,
        color: '#ddd',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
};

// -----------------------------------------------------------------------------
// Main App Component
// -----------------------------------------------------------------------------
const Index = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const theme = createTheme();

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <Payroleheader onMenuClick={toggleSidebar} />
                <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
            </Box>
        </ThemeProvider>
    );
};

export default Index;
